<template>
	<div class="orderList">
		<meta name="description" content="以诺教育成立于2014年，源起于其母公司诺亚财富（中国财富管理行业的开创者和领军者，2010年率先美国纽交所上市，股票代码NOAH）十多年的学习型组织沉淀，围绕“财富与人生”这个大主题，打造各类拓展视野、跨界创新、凝聚人脉、守护家庭、滋养身心的高端课程，全方位打造高尚、富有、快乐的人生，实现有形财富和无形财富的和谐统一。"/>
		<headTop></headTop>
		<div class="orderText">
			<div class="orderLeft">
          <div class="portrait"><img :src="zhUserUrl" class="zhImg"></div>
          <p class="portname">{{zhUser}}</p>
          <div class="orderLast">
            <router-link to="Myorder" tag="li" class="orderC">订单中心</router-link>
            <router-link to="MyBalance" tag="li" class="orderC">我的学费</router-link>
            <router-link to="scholarship" tag="li" class="orderC">我的奖学金</router-link>
            <router-link to="Mycoupons" tag="li" class="orderC">我的优惠券</router-link>
            <!--<router-link to="Invite" tag="li" class="orderC">好友邀请</router-link>-->
          </div>
        </div>
        <div class="orderRight">
            <router-view></router-view>
			</div>
			<div class="clear"></div>
		</div>
    	<Bottom class="zuidi"></Bottom>
	</div>
</template>
<script>
	import headTop from "../headTop/headTop"
    import Bottom from "../Bottom/Bottom"
    import src from "../../assets/moren.png"
	export default{
		name:'orderList',
		components:{headTop,Bottom},
		data(){
		  return{
		   zhUser:"",
		   zhUserUrl:src,
	       token:localStorage.getItem("token"),
		  }
		},
		methods:{
      
		},
		mounted(){
		 var that = this;
	   //初始化 用户信息
       that.$ajax({
          method:"post",
          url:"/api/UserInfo",
        })
        .then(function(data){
          that.zhUser = data.data.name;
        	that.zhUserUrl = data.data.avatar_url;
          if(data.data.error){
			  $(".lognOut").html("")
          	  $(".backdrop").css({"display":"block"})
          	  localStorage.clear(that.token)
          }
          if(that.zhUserUrl==""){
				that.zhUserUrl= src
          }else{
          	that.zhUserUrl=that.zhUserUrl
          }
        })
	 /*-----------------------------shua--------------------------------------*/
	 sessionStorage.setItem('xin',1)
		},
	}
</script>
<style scoped="scoped">
	.orderList{width:100%;background:#f4f5f9;min-height: 100%;}
  .orderList .orderText{width:1160px;margin:30px auto 265px;background:#fff;}
  .orderList .orderLeft{width:240px;height:100%;background:#fff;float: left;}
  .orderList .orderRight{float:right;width:920px;background:#fff;border-left:10px solid #f4f5f9;min-height: 700px;}
  .orderList .portrait{width:95px;height:95px;border-radius: 50%;margin:50px auto 18px;overflow:hidden;}
  .orderList .portname{width:100%;height:70px;border-bottom:1px solid #e6e6e6;text-align: center;}
  .orderList .orderLast{width:100%;margin-top:20px;}
  .orderList .orderC{width:100%;line-height:50px;text-align: center;font-size: 16px;cursor:pointer;display: block;}
  .orderList .orderCenter{font-size: 20px;font-weight: 100;margin:26px 30px;}
  .orderList .actions{color:#01b784;}
  /*添加文字样式*/
  .orderList .zhWordAct{color:#11cc99;}
  .orderList .zhhContent{display: flex;justify-content: center;padding-top: 30px;}
  .orderList .ivu-page-total{display: none;}
  .orderList .ivu-page li{border-radius: 50%;}
  .orderList .ivu-page li:hover{border:1px solid #11cc99;}
  .orderList .ivu-page li:hover a{color:#11cc99}
  .orderList .ivu-page .ivu-page-item-active:hover a{color:#ffffff}
  .orderList .ivu-page-item-active{background-color: #11cc99;border-color: #11cc99;}
  .orderList .zhTotal{width:100%;text-align: center;line-height: 50px;}
  .display{display: none;}
  .router-link-active{background:#11cc99;color:#fff;}
</style>




// WEBPACK FOOTER //
// orderList.vue?a19aca8e